import h from "photoswipe/lightbox";
import "photoswipe/style.css";
import { defineComponent as s, openBlock as n, createElementBlock as c, createElementVNode as m, createCommentVNode as o, ref as f, onMounted as g, Fragment as p, renderList as w, renderSlot as i, createVNode as y, normalizeProps as k, guardReactiveProps as v } from "vue";
const b = (e = {}, l = {
  immediate: !1
}) => {
  const t = new h({
    pswpModule: () => import("photoswipe"),
    ...e
  }), { immediate: a, beforeInit: r } = l;
  return r == null || r(t), t.init(), a && t.loadAndOpen(
    (e == null ? void 0 : e.index) ?? 0,
    (e == null ? void 0 : e.dataSource) ?? {
      gallery: e.gallery
    }
  ), t;
}, x = ["href", "data-pswp-src", "data-pswp-width", "data-pswp-height", "data-cropped"], N = ["src"], P = /* @__PURE__ */ s({
  props: {
    thumbnail: null,
    href: null,
    src: null,
    width: null,
    height: null,
    cropped: null
  },
  setup(e) {
    return (l, t) => e.href ? (n(), c("a", {
      key: 0,
      class: "vpis-item",
      href: e.href,
      "data-pswp-src": e.src,
      "data-pswp-width": e.width,
      "data-pswp-height": e.height,
      "data-cropped": e.cropped,
      target: "_blank"
    }, [
      m("img", {
        src: e.thumbnail || e.href || e.src,
        alt: ""
      }, null, 8, N)
    ], 8, x)) : o("", !0);
  }
}), $ = /* @__PURE__ */ s({
  props: {
    list: null,
    options: null,
    config: null
  },
  setup(e) {
    const l = e, t = f();
    return g(() => {
      b({
        gallery: t.value,
        children: "a",
        ...l.options
      }, l.config);
    }), (a, r) => (n(), c("div", {
      ref_key: "galleryRef",
      ref: t,
      class: "vpis-gallery"
    }, [
      e.list ? (n(!0), c(p, { key: 0 }, w(e.list, (d, u) => i(a.$slots, "item", {
        key: u,
        data: d
      }, () => [
        y(P, k(v(d)), null, 16)
      ])), 128)) : i(a.$slots, "default", { key: 1 })
    ], 512));
  }
});
export {
  $ as Gallery,
  P as Item,
  b as setGallery
};
